__turbopack_context__.v({
  "link": "QuickBookingArticle-module-sass-module__8T-YUW__link",
  "widget": "QuickBookingArticle-module-sass-module__8T-YUW__widget",
});
